// The old bell is switched off. The new bell comes with the chat corner.
export function NotificationBell(_props: Record<string, unknown>) {
  return null;
}

export default NotificationBell;
